import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { menuItems } from "../../models/navigation.model";
import { ResolverService } from "../../services/resolver/resolver.service";
import { Role } from "../../models/role.model";
import { environment } from "../../../../environments/environment";
import {
  PermrissionType,
  PermissionView,
} from "../../models/permission-type.model";
import { MatDialog } from "@angular/material/dialog";
import * as moment from "moment-timezone";
import { DashboardFacadeService } from "src/app/modules/dashboard/services/dashboard-facade.service";
import { SnackBarService } from "src/app/shared";
import { PermissionService } from "../../services/permission/permission.service";
import { Router } from "@angular/router";
import { LocalStorageService } from "../../services/local-storage/local-storage.service";
import { PostpaidService } from "src/app/modules/postpaid/services/postpaid.service";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent implements OnInit, AfterViewInit {
  public userName: string;
  public userMail: string;
  public userAvatar: string;
  public userRole: Role;
  public resellerItems: menuItems[];
  adminItems: menuItems[] = [];
  sellerItems: menuItems[] = [];
  navItems: menuItems[] = [];
  userTimezone: string;
  isSubUser: boolean = false;

  loginTwoStepDetails;

  isTwoFactorVerified: boolean = true;

  @ViewChild("documentAlertModal") documentAlertModal;
  permissionGroups: any;
  haveBulkDigitalPermission:boolean=false;
  imgAlt = environment.imageAlt;
  environmentConfig = environment;

  constructor(
    private resolvedService: ResolverService,
    private dialog: MatDialog,
    private dashboardSerivce: DashboardFacadeService,
    private snackbarService: SnackBarService,
    private permissionService: PermissionService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private postpaidService: PostpaidService
  ) {}

  ngOnInit() {
    this.haveBulkDigitalPermission =
      this.resolvedService.userInitInfo.profile.can_create_bulk_order;
    this.getUser();
    // this.checkPostPaid()
    this.getLoginTwoStepData();
    if (this.resolvedService.userInitInfo.profile.timezone_data) {
      this.userTimezone =
        this.resolvedService.userInitInfo.profile.timezone_data.code;
    } else {
      this.userTimezone = "America/Los_Angeles";
    }
    this.constructNavigation();
    this.getAccessList();

    this.resolvedService.updateInitInfo.subscribe((update) => {
      if (update) {
        this.getUser();
        this.constructNavigation();
        this.getAccessList();
      }
    });
  }

  constructNavigation() {
    this.resellerItems = [
      {
        title: "Dashboard",
        children: [
          {
            value: "My Wallet/Balance",
            uri: ["/user/wallet"],
            is_permitted: true,
          },
          {
            value: "My Price List",
            uri: ["/user/price-list"],
            is_permitted: this.permissionGroups.main_or_accountant,
          },
          {
            value: "Display Price List",
            uri: ["/user/display-price-list"],
            is_permitted: this.permissionGroups.main_or_accountant,
          },
          {
            value: "Customer Price List",
            uri: ["/customers/default-price-list"],
            is_permitted: this.permissionGroups.main_or_accountant,
          },
          {
            value: "Retailer Product List",
            uri: ["/reports/retailer-products"],
            is_permitted: true,
          },
        ],
        icon: "dashboard",
        is_permitted: this.permissionGroups.main_or_accountant,
      },
      {
        title: "Shop",
        children: [],
        uri: "/egifts",
        icon: "shop",
        is_permitted:
          this.permissionService.companyDigital &&
          this.permissionGroups.main_or_digital,
      },
      {
        title: "Postpaid",
        children: [
          {
            value: "My Postpaid List",
            uri: ["/postpaid/list"],
            is_permitted: true,
          },
          {
            value: "Payment List",
            uri: ["/postpaid/payments"],
            is_permitted: true,
          },
          {
            value: "Weekly Invoice List",
            uri: ["/postpaid/invoices"],
            is_permitted: true,
          },
          {
            value: "Postpaid Statement",
            uri: ["/postpaid/statements"],
            is_permitted: true,
          },
        ],
        icon: "credit_card",
        is_permitted: this.permissionGroups.main,
      },
      {
        title: "Bulk Digital Orders",
        children: [
          {
            value: "Bulk Digital Orders List",
            uri: "/bulk-digital-orders/list",
            is_permitted:
              this.haveBulkDigitalPermission &&
              this.permissionService.companyDigital,
          },
          {
            value: "Email Template",
            uri: "/bulk-digital-orders/email-template/list",
            is_permitted:
              this.haveBulkDigitalPermission &&
              this.permissionService.companyDigital,
          },
        ],
        icon: "card_giftcard",
        is_permitted:
          this.haveBulkDigitalPermission &&
          this.permissionService.companyDigital,
      },
      // {
      //   title: "Cryptocurrency",
      //   children: [
      //     { value: "Market", uri: ["/crypto-currency"], is_permitted: true },
      //     {
      //       value: "Commission List",
      //       uri: ["/crypto-currency/commissions"],
      //       is_permitted: this.permissionGroups.main_or_accountant,
      //     },
      //   ],
      //   icon: "attach_money",
      //   is_permitted:
      //     this.permissionService.companyCrypto &&
      //     (this.permissionGroups.main_or_accountant ||
      //       this.permissionGroups.main_or_crypto),
      // },
      {
        title: "Physical Gift Cards",
        children: [
          {
            value: "‌Single Activate",
            uri: "/gifts/activate",
            is_permitted: true,
          },
          {
            value: "Bulk Activation",
            uri: "/gifts/bulk-activate",
            is_permitted: true,
          },
          { value: "Card Status", uri: "/gifts/status", is_permitted: true },
          {
            value: "Order Physical Card",
            uri: "/gifts/physical-shop",
            is_permitted: true,
          },
          {
            value: "Orders History",
            uri: "/gifts/physical-orders",
            is_permitted: true,
          },
        ],
        icon: "card_giftcard",
        is_permitted:
          this.permissionService.companyPhysical &&
          this.permissionGroups.main_or_physical,
      },
      {
        title: "POS",
        children: [
          {
            value: "Shop",
            uri: "/gifts/accessory",
            is_permitted: true,
          },
          {
            value: "Orders",
            uri: "/gifts/accessory/orders",
            is_permitted: true,
          },
          {
            value: "Payments",
            uri: "/gifts/accessory/payments",
            is_permitted: true,
          },
        ],
        icon: "earbuds",
        is_permitted:
          this.permissionService.companyPhysical &&
          this.permissionGroups.main_or_physical,
      },
      // {
      //   title: "Physical Market",
      //   children: [
      //     {
      //       value: "Physical Shop",
      //       uri: "/gifts/physical-shop",
      //       is_permitted: true,
      //     },
      //     {
      //       value: "Physical Orders",
      //       uri: "/gifts/physical-orders",
      //       is_permitted: true,
      //     },
      //   ],
      //   icon: "card_giftcard",
      //   is_permitted:
      //     this.permissionService.companyPhysical &&
      //     this.permissionGroups.main_or_physical,
      // },
      {
        title: "Customer",
        children: [
          { value: "List", uri: "/customers", is_permitted: true },
          { value: "Finance", uri: "/customers/finance", is_permitted: true },
          {
            value: "Daily Invoice",
            uri: "/customers/invoice",
            is_permitted: true,
          },
          // {
          //   value: "Register",
          //   uri: "/customers/register",
          //   is_permitted: this.permissionGroups.main,
          // },
          // { value: 'Register Via Code', uri: '/customers/register/by-code', is_permitted: this.permissionGroups.main },
          {
            value: "Invite Customer",
            uri: "/customers/invite",
            is_permitted: this.permissionGroups.main,
          },
          {
            value: "Debit/Credit Notes",
            uri: ["/customers/debit-credit-notes"],
            is_permitted:
              this.permissionService.isOwner ||
              this.permissionService.isAdmin ||
              this.permissionService.isOwner,
          },
        ],

        icon: "supervisor_account",
        is_permitted: this.permissionGroups.main_or_accountant,
      },
      {
        title: "Reports",
        children: [
          {
            value: "Sales Report",
            uri: "/reports/sales",
            is_permitted: this.permissionGroups.main_or_accountant,
          },
          {
            value: "Sales Transactions Report",
            uri: "/reports/sales-transactions",
            is_permitted: true,
          },
          {
            value: "Order Report",
            uri: "/reports/orders",
            is_permitted: this.checkReportTabVisibility(),
          },
          {
            value: "Daily Sales Invoice",
            uri: ["/user/invoice"],
            is_permitted: true,
          },
          {
            value: "Debit/Credit Notes",
            uri: ["/reports/debit-credit-notes"],
            is_permitted:
              this.permissionService.isOwner ||
              this.permissionService.isAdmin ||
              this.permissionService.isOwner,
          },
          // { value: 'Transactions Report', uri: '/reports/transactions', is_permitted: this.permissionGroups.main_or_accountant || this.permissionGroups.main_or_digital },
        ],
        icon: "show_chart",
        is_permitted: this.checkReportTabVisibility(),
      },
      {
        title: "Finance",
        children: [
          {
            value: "Financial Activity",
            uri: "/finance",
            is_permitted: true,
          },
          {
            value: "Online Payments",
            uri: "/online-payments",
            is_permitted: true,
          },
          {
            value: "Exchange Rate Report",
            uri: "/finance/exchange",
            is_permitted: true,
          },
          { value: "Profit", uri: "/finance/profit", is_permitted: true },
        ],
        icon: "attach_money",
        is_permitted: this.permissionGroups.main_or_accountant,
      },
      {
        title: "Sub-User",
        children: [
          {
            value: "Users",
            uri: "/dashboard/sub-users",
            is_permitted: true,
          },
          {
            value: "Terminals",
            uri: "/dashboard/terminals",
            is_permitted: true,
          },
        ],
        icon: "supervisor_account",
        is_permitted: this.checkSubUserTabVisibility(),
      },
      {
        title: "Settings",
        children: [],
        uri: "/dashboard/settings",
        icon: "settings",
        is_permitted: this.checkSettingTabVisibility(),
      },
      {
        title: "Support",
        children: [],
        uri: `${environment.freshdeskUrl}/customer/login`,
        icon: "contact_support",
        new: true,
        is_permitted: true,
      },
      {
        title: "Video Tutorial",
        children: [],
        uri: environment.videoUrl,
        icon: "play_circle_filled",
        new: true,
        is_permitted: true,
      },
    ];

    this.adminItems = [
      {
        title: "Dashboard",
        children: [
          {
            value: "Customer Price List",
            uri: ["/customers/default-price-list"],
            is_permitted: true,
          },
          // {
          //   value: "Customer Product List",
          //   uri: ["/customers/product-list"],
          //   is_permitted: true,
          // },
          {
            value: "Customer Gateway List",
            uri: ["/customers/default-gateway-list"],
            is_permitted: true,
          },
          {
            value: "Retailer Product List",
            uri: ["/reports/retailer-products"],
            is_permitted: true,
          },
        ],
        icon: "dashboard",
        is_permitted: this.permissionGroups.main_or_accountant,
      },
      {
        title: "Shop",
        children: [],
        uri: "/egifts",
        icon: "shop",
        is_permitted:
          this.permissionService.companyDigital &&
          this.permissionGroups.main_or_digital,
      },
      {
        title: "Postpaid",
        children: [
          {
            value: "Postpaid Companies",
            uri: ["/postpaid/companies"],
            is_permitted: true,
          },
          {
            value: "Payment List",
            uri: ["/postpaid/payments/report"],
            is_permitted: true,
          },
          {
            value: "Weekly Invoice List",
            uri: ["/postpaid/invoices/report"],
            is_permitted: true,
          },
        ],
        icon: "credit_card",
        is_permitted: this.permissionGroups.main,
      },
      // {
      //   title: "Postpaid Companies",
      //   children: [],
      //   uri: "/postpaid/companies",
      //   icon: "credit_card",
      //   is_permitted: this.permissionGroups.main,
      // },
      // {
      //   title: "Cryptocurrency",
      //   children: [
      //     { value: "Market", uri: ["/crypto-currency"], is_permitted: true },
      //     {
      //       value: "Commission List",
      //       uri: ["/crypto-currency/commissions"],
      //       is_permitted: this.permissionGroups.main_or_accountant,
      //     },
      //   ],
      //   icon: "attach_money",
      //   is_permitted:
      //     this.permissionService.companyCrypto &&
      //     (this.permissionGroups.main_or_accountant ||
      //       this.permissionGroups.main_or_crypto),
      // },
      {
        title: "Physical Gift Cards",
        children: [
          { value: "Card Status", uri: "/gifts/status", is_permitted: true },
        ],
        icon: "card_giftcard",
        is_permitted:
          this.permissionService.companyPhysical &&
          this.permissionGroups.main_or_physical,
      },
      {
        title: "Customer",
        children: [
          { value: "List", uri: "/customers", is_permitted: true },
          { value: "Finance", uri: "/customers/finance", is_permitted: true },
          {
            value: "Daily Invoice",
            uri: "/customers/invoice",
            is_permitted: true,
          },
          {
            value: "Register",
            uri: "/customers/register",
            is_permitted: (this.permissionService.isSysAdmin && this.permissionService.isOwner) || (this.permissionService.isSysAdmin && this.permissionService.isAdmin),
          },
          { value: 'Register Via Code', uri: '/customers/register/by-code', is_permitted: this.permissionGroups.main },
          {
            value: "Invite Customer",
            uri: "/customers/invite",
            is_permitted: this.permissionGroups.main,
          },
          {
            value: "Debit/Credit Notes",
            uri: ["/customers/debit-credit-notes"],
            is_permitted:
              this.permissionService.isOwner ||
              this.permissionService.isAdmin ||
              this.permissionService.isOwner,
          },
          // {
          //   value: "Legal Documents",
          //   uri: "/dashboard/users-documents",
          //   is_permitted: this.permissionGroups.main,
          // },
        ],
        icon: "supervisor_account",
        is_permitted: this.permissionGroups.main_or_accountant,
      },
      {
        title: "Sales Managers",
        children: [
          {
            value: "List",
            uri: "/customers/sales-managers/list",
            is_permitted: true,
          },
          {
            value: "Products Report",
            uri: "/customers/sales-managers/report",
            is_permitted: true,
          },
          {
            value: "Customers Report",
            uri: "/customers/sales-managers/customers-report",
            is_permitted: true,
          },
        ],
        icon: "groups",
        is_permitted: this.permissionGroups.main_or_accountant,
      },
      {
        title: "Finance",
        children: [
          {
            value: "Financial Activity",
            uri: "/finance",
            is_permitted: true,
          },
          { value: "Profit", uri: "/finance/admin-profit", is_permitted: true },
        ],
        icon: "attach_money",
        is_permitted: this.permissionGroups.main_or_accountant,
      },
      {
        title: "Reports",
        children: [
          {
            value: "Sales Report",
            uri: "/reports/sales",
            is_permitted: this.permissionGroups.main_or_accountant,
          },
          {
            value: "Sales Transactions Report",
            uri: "/reports/sales-transactions",
            is_permitted: true,
          },
          {
            value: "Debit/Credit Notes",
            uri: ["/reports/debit-credit-notes"],
            is_permitted:
              this.permissionService.isOwner ||
              this.permissionService.isAdmin ||
              this.permissionService.isOwner,
          },
          // { value: 'Order Report', uri: '/reports/orders', is_permitted: this.checkReportTabVisibility() },
        ],
        icon: "show_chart",
        is_permitted: this.checkReportTabVisibility(),
      },
      {
        title: "Notifications",
        children: [
          {
            value: "Groups",
            uri: "/notifications/groups",
            is_permitted: !this.isSubUser,
          },
          // { value :'Templates' , uri:'/notifications/templates', is_permitted:!this.isSubUser},
          {
            value: "Campaigns",
            uri: "/notifications/events",
            is_permitted: !this.isSubUser,
          },
          {
            value: "Contacts",
            uri: "/notifications/contacts",
            is_permitted: !this.isSubUser,
          },
          {
            value: "Contacts Groups",
            uri: "/notifications/contacts-groups",
            is_permitted: !this.isSubUser,
          },
        ],
        icon: "notifications",
        is_permitted: this.permissionGroups.main,
      },
      {
        title: "Bulk Digital Orders",
        children: [
          {
            value: "Bulk Digital Orders List",
            uri: "/bulk-digital-orders/list",
            is_permitted:
              this.haveBulkDigitalPermission &&
              this.permissionService.companyDigital,
          },
          {
            value: "Email Template",
            uri: "/bulk-digital-orders/email-template/list",
            is_permitted:
              this.haveBulkDigitalPermission &&
              this.permissionService.companyDigital,
          },
        ],
        icon: "card_giftcard",
        is_permitted:
          this.haveBulkDigitalPermission &&
          this.permissionService.companyDigital,
      },
      {
        title: "Promotions",
        children: [],
        uri: "dashboard/promotions",
        icon: "notifications_active",
        is_permitted: !this.isSubUser,
      },
      {
        title: "Sub-User",
        children: [
          {
            value: "Users",
            uri: "/dashboard/sub-users",
            is_permitted: true,
          },
          {
            value: "Terminals",
            uri: "/dashboard/terminals",
            is_permitted: true,
          },
        ],
        icon: "supervisor_account",
        is_permitted: this.checkSubUserTabVisibility(),
      },
      {
        title: "Settings",
        children: [],
        uri: "/dashboard/settings",
        icon: "settings",
        is_permitted: this.checkSettingTabVisibility(),
      },
      {
        title: "Support",
        children: [],
        uri: `${environment.freshdeskUrl}/customer/login`,
        icon: "contact_support",
        new: true,
        is_permitted: true,
      },
      {
        title: "Video Tutorial",
        children: [],
        uri: environment.videoUrl,
        icon: "play_circle_filled",
        new: true,
        is_permitted: true,
      },
    ];

    this.sellerItems = [
      {
        title: "Dashboard",
        children: [
          {
            value: "My Wallet/Balance",
            uri: ["/user/wallet"],
            is_permitted: true,
          },
          {
            value: "My Price List",
            uri: ["/user/price-list"],
            is_permitted: this.permissionGroups.main_or_accountant,
          },
          {
            value: "Display Price List",
            uri: ["/user/display-price-list"],
            is_permitted: this.permissionGroups.main_or_accountant,
          },
          {
            value: "Retailer Product List",
            uri: ["/reports/retailer-products"],
            is_permitted: true,
          },
        ],
        icon: "dashboard",
        is_permitted: this.permissionGroups.main_or_accountant,
      },
      {
        title: "Shop",
        children: [],
        uri: "/egifts",
        icon: "shop",
        is_permitted:
          this.permissionService.companyDigital &&
          this.permissionGroups.main_or_digital,
      },
      {
        title: "Postpaid",
        children: [
          {
            value: "My Postpaid List",
            uri: ["/postpaid/list"],
            is_permitted: true,
          },
          {
            value: "Payment List",
            uri: ["/postpaid/payments"],
            is_permitted: true,
          },
          {
            value: "Weekly Invoice List",
            uri: ["/postpaid/invoices"],
            is_permitted: true,
          },
        ],
        icon: "credit_card",
        is_permitted: this.permissionGroups.main,
      },
      {
        title: "Bulk Digital Orders",
        children: [
          {
            value: "Bulk Digital Orders List",
            uri: "/bulk-digital-orders/list",
            is_permitted:
              this.haveBulkDigitalPermission &&
              this.permissionService.companyDigital,
          },
          {
            value: "Email Template",
            uri: "/bulk-digital-orders/email-template/list",
            is_permitted:
              this.haveBulkDigitalPermission &&
              this.permissionService.companyDigital,
          },
        ],
        icon: "card_giftcard",
        is_permitted:
          this.haveBulkDigitalPermission &&
          this.permissionService.companyDigital,
      },
      // {
      //   title: "Cryptocurrency",
      //   children: [],
      //   uri: "/crypto-currency",
      //   icon: "attach_money",
      //   is_permitted:
      //     this.permissionService.companyCrypto &&
      //     (this.permissionGroups.main_or_accountant ||
      //       this.permissionGroups.main_or_crypto),
      // },
      {
        title: "Physical Gift Cards",
        children: [
          {
            value: "‌Single Activate",
            uri: "/gifts/activate",
            is_permitted: true,
          },
          {
            value: "Bulk Activation",
            uri: "/gifts/bulk-activate",
            is_permitted: true,
          },
          { value: "Card Status", uri: "/gifts/status", is_permitted: true },
          {
            value: "Order Physical Card",
            uri: "/gifts/physical-shop",
            is_permitted: true,
          },
          {
            value: "Orders History",
            uri: "/gifts/physical-orders",
            is_permitted: true,
          },
        ],
        icon: "card_giftcard",
        is_permitted:
          this.permissionService.companyPhysical &&
          this.permissionGroups.main_or_physical,
      },
      {
        title: "POS",
        children: [
          {
            value: "Shop",
            uri: "/gifts/accessory",
            is_permitted: true,
          },
          {
            value: "Orders",
            uri: "/gifts/accessory/orders",
            is_permitted: true,
          },
          {
            value: "Payments",
            uri: "/gifts/accessory/payments",
            is_permitted: true,
          },
        ],
        icon: "earbuds",
        is_permitted:
          this.permissionService.companyPhysical &&
          this.permissionGroups.main_or_physical,
      },
      {
        title: "Physical Market",
        children: [
          {
            value: "Physical Shop",
            uri: "/gifts/physical-shop",
            is_permitted: true,
          },
          {
            value: "Physical Orders",
            uri: "/gifts/physical-orders",
            is_permitted: true,
          },
        ],
        icon: "card_giftcard",
        is_permitted:
          this.permissionService.companyPhysical &&
          this.permissionGroups.main_or_physical,
      },
      {
        title: "Reports",
        children: [
          {
            value: "Sales Report",
            uri: "/reports/sales",
            is_permitted: this.permissionGroups.main_or_accountant,
          },
          {
            value: "Sales Transactions Report",
            uri: "/reports/sales-transactions",
            is_permitted: true,
          },
          {
            value: "Order Report",
            uri: "/reports/orders",
            is_permitted: this.checkReportTabVisibility(),
          },
          {
            value: "Daily Sales Invoice",
            uri: ["/user/invoice"],
            is_permitted: true,
          },
          {
            value: "Debit/Credit Notes",
            uri: ["/reports/debit-credit-notes"],
            is_permitted:
              this.permissionService.isOwner ||
              this.permissionService.isAdmin ||
              this.permissionService.isOwner,
          },
          // { value: 'Transactions Report', uri: '/reports/transactions', is_permitted: this.permissionGroups.main_or_accountant || this.permissionGroups.main_or_digital },
        ],
        icon: "show_chart",
        is_permitted: this.checkReportTabVisibility(),
      },
      {
        title: "Finance",
        children: [
          {
            value: "Financial Activity",
            uri: "/finance",
            is_permitted: true,
          },
          {
            value: "Online Payments",
            uri: "/online-payments",
            is_permitted: true,
          },
          {
            value: "Exchange Rate Report",
            uri: "/finance/exchange",
            is_permitted: true,
          },
        ],
        icon: "attach_money",
        is_permitted: this.permissionGroups.main_or_accountant,
      },
      {
        title: "Sub-User",
        children: [
          {
            value: "Users",
            uri: "/dashboard/sub-users",
            is_permitted: true,
          },
          {
            value: "Terminals",
            uri: "/dashboard/terminals",
            is_permitted: true,
          },
        ],
        icon: "supervisor_account",
        is_permitted: this.checkSubUserTabVisibility(),
      },
      {
        title: "Settings",
        children: [],
        uri: "/dashboard/settings",
        icon: "settings",
        is_permitted: this.checkSettingTabVisibility(),
      },
      {
        title: "Support",
        children: [],
        uri: `${environment.freshdeskUrl}/customer/login`,
        icon: "contact_support",
        new: true,
        is_permitted: true,
      },
      {
        title: "Video Tutorial",
        children: [],
        uri: environment.videoUrl,
        icon: "play_circle_filled",
        new: true,
        is_permitted: true,
      },
    ];

    if (!this.resolvedService.userInitInfo.is_password_updated) {
      this.sellerItems = [
        {
          title: "Settings",
          children: [],
          uri: "/dashboard/settings",
          icon: "settings",
          is_permitted: this.checkSettingTabVisibility(),
        },
        {
          title: "Support",
          children: [],
          uri: `${environment.freshdeskUrl}/customer/login`,
          icon: "contact_support",
          new: true,
          is_permitted: true,
        },
        {
          title: "Video Tutorial",
          children: [],
          uri: environment.videoUrl,
          icon: "play_circle_filled",
          new: true,
          is_permitted: true,
        },
        // { title: 'Sub-User', children: [], uri: '/dashboard/sub-users', icon: 'supervisor_account', is_permitted: this.checkSubUserTabVisibility() },
      ];
      this.resellerItems = this.sellerItems;
      this.adminItems = this.sellerItems;
      this.snackbarService.showSnack("Please update your password to continue");
      return;
    }

    if (
      this.isSubUser &&
      !this.resolvedService.userInitInfo.google_two_step &&
      false
    ) {
      this.sellerItems = [
        {
          title: "Support",
          children: [],
          uri: `${environment.freshdeskUrl}/customer/login`,
          icon: "contact_support",
          new: true,
          is_permitted: true,
        },
        {
          title: "Video Tutorial",
          children: [],
          uri: `${environment.videoUrl}`,
          icon: "play_circle_filled",
          new: true,
          is_permitted: true,
        },
        {
          title: "Settings",
          children: [],
          uri: "/dashboard/settings",
          icon: "settings",
          is_permitted: this.checkSettingTabVisibility(),
        },
      ];
      this.resellerItems = this.sellerItems;
      this.adminItems = this.sellerItems;
      this.router.navigate(["/dashboard", "settings"]);
    }
  }

  getLoginTwoStepData() {
    this.dashboardSerivce.getLoginTwoStepVerification().subscribe((data) => {
      if (!data.has_two_factor) {
        if (!this.isSubUser) {
          if (!this.localStorageService.getData("shown_warning")) {
            this.openDialog(this.documentAlertModal);
            this.localStorageService.setData("shown_warning", "true");
          }
        }
      }
    });
  }

  checkReportTabVisibility(): boolean {
    return (
      !this.isSubUser ||
      this.permissionService.isPhysicalSeller ||
      this.permissionService.isDigitalSeller ||
      this.permissionService.isAccountant
    );
  }

  checkSettingTabVisibility(): boolean {
    // return !this.isSubUser
    return true;
  }

  checkSubUserTabVisibility(): boolean {
    return !this.isSubUser;
  }

  ngAfterViewInit(): void {
    // if (this.userRole.role_id == environment.role_types.reseller && !this.resolvedService.userInitInfo.profile.reseller) {
    // if (moment() < moment.utc('2023-09-26T12:00:00', 'YYYY-MM-DDTHH:mm:ss')) {
    // }
    // }
  }

  getUser() {
    this.isSubUser =
      !this.permissionService.isAdmin && !this.permissionService.isOwner;
    this.userName = this.resolvedService.userInitInfo.profile.company;
    this.userMail =
      this.resolvedService.userInitInfo.merchant_detail.user_detail.email;
    this.userAvatar = this.resolvedService.userInitInfo.profile.company_logo;
    this.userRole = this.resolvedService.userInitInfo.profile.role;

    this.permissionGroups = {
      main: !this.isSubUser,
      main_or_accountant:
        !this.isSubUser || this.permissionService.isAccountant,
      main_or_digital:
        !this.isSubUser || this.permissionService.isDigitalSeller,
      main_or_physical:
        !this.isSubUser || this.permissionService.isPhysicalSeller,
      main_or_crypto: !this.isSubUser || this.permissionService.isCryptoSeller,
    };
  }

  getAccessList() {
    switch (this.resolvedService.userInitInfo.profile.role.role_id) {
      case environment.role_types.admin:
        this.navItems = this.adminItems;
        break;
      case environment.role_types.seller:
        this.navItems = this.sellerItems;
        this.getMyPostPaid();
        break;
      case environment.role_types.reseller:
        this.navItems = this.resellerItems;
        this.getMyPostPaid();
        break;
    }
  }

  getMyPostPaid() {
    this.postpaidService
      .getMyPostpaidList({ active: true })
      .subscribe((res) => {
        if (res.results.length == 0) {
          this.navItems = this.navItems.filter(
            (nav) => nav.title != "Postpaid"
          );
        }
      });
  }

  // userAccessExceptions() {
  //   const permissions = this.resolvedService.userInitInfo.panel_permissions;

  //   permissions.map(item => {
  //     if (item.action == PermissionView.exclude) {

  //       if (item.permission_type == PermrissionType.crypto) {
  //         this.navItems = this.navItems.filter(item => item.title !== 'Cryptocurrency');
  //       }

  //       if (item.permission_type == PermrissionType.digital) {
  //         this.navItems = this.navItems.filter(item => item.title !== 'Shop');
  //       }

  //       if (item.permission_type == PermrissionType.physical) {
  //         this.navItems = this.navItems.filter(item => item.title !== 'Physical Gift Cards');
  //       }
  //     }
  //   })

  //   this.reportsAccessExceptions(permissions);
  // }

  // reportsAccessExceptions(list: any[]) {
  //   let cardsBan = list.filter(item => {
  //     if (item.action == PermissionView.exclude) {
  //       if (item.permission_type == PermrissionType.digital
  //         || item.permission_type == PermrissionType.physical) return item
  //     }
  //   });

  //   if (cardsBan.length == 2) this.navItems.find(item => item.title == 'Reports').children.splice(1, 2);
  // }

  openDialog(content) {
    this.dialog.open(content, { disableClose: false, width: "450px" });
  }

  closeDialogs() {
    this.dialog.closeAll();
  }

  getMigrationTime() {
    let fromDate = moment.utc("2021-01-05T9:00:00", "YYYY-MM-DDTHH:mm:ss");
    fromDate = fromDate.tz(this.userTimezone);
    let toDate = moment.utc("2021-01-05T12:00:00", "YYYY-MM-DDTHH:mm:ss");
    toDate = toDate.tz(this.userTimezone);
    let str = `${fromDate.format(
      "dddd, MMMM DD, YYYY HH:mm a"
    )} to ${toDate.format("dddd, MMMM DD, YYYY HH:mm a")}(${
      this.userTimezone
    })`;
    return str;
  }
}
